import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QrPaymentService } from '../../../../services/qr-payment.service';
import { AuthService } from 'src/app/pages/auth/abstraction/auth.service';
import { AuthSocketService } from 'src/app/pages/auth/services/auth-socket.service';
import { OPERATION_STATUS } from 'src/app/pages/transactions/models/operations';
import { timer } from 'rxjs';
import { switchMap, take, takeWhile } from 'rxjs/operators';
import { Utils } from 'src/app/pages/auth/utils/Utils';
import { TYPE_MINIAPP } from 'src/app/pages/auth/models/Onboarding';

@Component({
  selector: 'app-payment-creation',
  templateUrl: './payment-creation.component.html',
  styleUrl: './payment-creation.component.scss',
})
export class PaymentCreationComponent implements OnInit {
  isLoading = true;
  isSuccess = false;
  error: string | null = null;
  txId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private qrPaymentService: QrPaymentService,
    private authSvc: AuthService,
    private authSocketService: AuthSocketService,
  ) {}

  ngOnInit(): void {
    if (this.authSvc.onboardingState.value.signature) {
      this.authSocketService.connectWidgetSocket(this.authSvc.onboardingState.value.signature);
      this.listenToSocket();
    }
    this.route.queryParams.subscribe((params) => {
      const txId = params['txId'];
      this.txId = txId;

      if (!txId) {
        this.error = 'Error al realizar el pago';
        this.isLoading = false;
        return;
      }
      this.qrPaymentService.createPayment(txId).subscribe({
        next: () => {
          timer(0, 5000)
            .pipe(
              switchMap(() =>
                this.qrPaymentService.getPaymentStatus(
                  this.authSvc.onboardingState.value.signature,
                ),
              ),
              take(6),
              takeWhile(
                (data) =>
                  data.status !== OPERATION_STATUS.COMPLETED &&
                  data.status !== OPERATION_STATUS.FAILED,
                true,
              ),
            )
            .subscribe((data) => {
              if (data.status === OPERATION_STATUS.COMPLETED) {
                this.isSuccess = true;
                this.isLoading = false;
              }

              if (data.status === OPERATION_STATUS.FAILED) {
                this.error = 'Error al realizar el pago';
                this.isLoading = false;
              }
            });
        },
        error: () => {
          let errorMessage = 'Error al realizar el pago';

          this.error = errorMessage;
          this.isLoading = false;
        },
      });
    });
  }

  listenToSocket() {
    let socket = this.authSocketService.widgetSocket;
    socket.on('widgetStatusUpdate', () => {
      this.qrPaymentService
        .getPaymentStatus(this.authSvc.onboardingState.value.signature)
        .subscribe((data: any) => {
          if (data.status === OPERATION_STATUS.COMPLETED) {
            this.isSuccess = true;
            this.isLoading = false;
          } else if (data.status === OPERATION_STATUS.FAILED) {
            this.error = 'Error al realizar el pago';
            this.isLoading = false;
          }

          if (
            data.status === OPERATION_STATUS.FAILED ||
            data.status === OPERATION_STATUS.COMPLETED
          ) {
            setTimeout(() => {
              this.redirectWithParams();
            }, 2000);
          }
          // Close window after 2 seconds
        });
    });
  }

  redirectWithParams() {
    const currentState = this.authSvc.onboardingState.value;
    const url = new URLSearchParams({
      appOrigin: currentState.appOrigin,
    }).toString();

    Utils.sendMessageToParent(
      TYPE_MINIAPP.EXIT,
      {
        url,
        success: true,
      },
      currentState.appOrigin,
    );
  }
}
